import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { Box, Dialog, Typography, Button } from "@mui/material";
import SetButtonValue from "./SetButtonValue";
import styles from "./styles.module.css";
import { useLocation } from "react-router-dom";
import EditStack from "../../EditStack/EditStack";
import { useDispatch, useSelector } from "react-redux";
import {
  placeAAABet,
  placeAndarBaharBet,
  placebaccarat,
  placeBetRoualete,
  placebollywood,
  placecard32,
  placedrogontiger,
  placedrogontigerlion,
  placelucky,
  placeonedaydt,
  placeteenpatti,
  placeteenpatti20,
  placeteenpattitwocard,
  placetwocardteenpatti,
} from "../../../store/slices/betSlice";
import { showError, showSuccess } from "../../../utils/toast";
import { GetEditStake } from "../../../store/slices/sportsSlice";
import useProfileSocket from "../../../api/userprofilesocket";

const BetScreen = ({
  open,
  onClose,
  selectedBet,
  onSubmit,
  socketData,
  remainingTime,
  gameId,
  roundId,
  amountList = [50, 100, 500, 1000, 5000, 10000, 50000, 100000],
  minRange = "100",
  maxRange = "100000",
}) => {
  const [currentAmountList, setCurrentAmountList] = useState([]);
  const [isEditStackOpen, setIsEditStackOpen] = useState(false);
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSetButtonValueOpen, setIsSetButtonValueOpen] = useState(false);
  const userId = useSelector((state) => state.auth.userId);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const handleAmountClick = (amount) => {
    setSelectedAmount((prev) => (prev ? prev + amount : amount));
  };

  const { profileData: socketProfile } = useProfileSocket(userId);
  const prevRoundIdRef = useRef(null);

useEffect(() => {
    if (
        roundId &&
        prevRoundIdRef.current != null &&
        prevRoundIdRef.current !== roundId
    ) {
        // round change ho gaya — purana selected bet/amount clear karo, dialog band karo
        setSelectedAmount(null);
        if (open) {
            onClose();
        }
    }
    prevRoundIdRef.current = roundId;
}, [roundId]);

  // ─── NEW: MIN / MAX / INALL  / CLEAR handlers ────────────────────────────
  const handleMinClick = () => {
    const min = parseFloat(minRange) || 0;
    setSelectedAmount(min);
  };

  const handleMaxClick = () => {
    const max = parseFloat(maxRange) || 0;
    setSelectedAmount(max);
  };

  // const handleAllInClick = () => {
  //     const max = parseFloat(maxRange) || 0;
  //     setSelectedAmount(socketProfile?.balance ?? profileData?.balance ?? 0 );//sapna
  // };

  const handleAllInClick = () => {
    const max = parseFloat(maxRange) || 0;
    setSelectedAmount(socketProfile?.balance ?? 0);
  };

  const handleClearClick = () => {
    setSelectedAmount(null);
  };
  // ─────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    if (open) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [open]);

  const handleEditClick = () => {
    setIsSetButtonValueOpen(true);
  };

  const handleSetButtonValueClose = () => {
    setIsSetButtonValueOpen(false);
  };

  const handleEditStackClose = () => {
    setIsEditStackOpen(false);
  };

  useEffect(() => {
    if (amountList && amountList.length > 0) {
      const mapped = amountList.map((item) =>
        typeof item === "object"
          ? item
          : { label: item.toString(), value: item },
      );
      setCurrentAmountList(mapped);
    }
  }, [amountList]);
  const handleUpdateAmountList = (selectedValues) => {
    const newList = selectedValues
      .map((item) => {
        let value = item.value;
        if (typeof value === "string" && value.toLowerCase().endsWith("k")) {
          value = parseFloat(value) * 1000;
        } else {
          value = parseFloat(value);
        }
        return {
          label: item.label,
          value: value,
        };
      })
      .filter((item) => !isNaN(item.value) && item.value > 0)
      .sort((a, b) => a.value - b.value);

    setCurrentAmountList(
      newList.length > 0
        ? newList
        : amountList.map((amt) => ({ label: amt.toString(), value: amt })),
    );
    setIsSetButtonValueOpen(false);
    setIsEditStackOpen(false);
  };

  const initialValues = currentAmountList.map((item) => ({
    label: item.label,
    value: item.value.toString(),
  }));

  const dialogBackgroundClass =
    selectedBet?.buttonType === "BlueButton"
      ? styles.betDialog_container_blue
      : selectedBet?.buttonType === "RedButton"
        ? styles.betDialog_container_pink
        : styles.betDialog_container;

  const amountButtonClass =
    selectedBet?.buttonType === "RedButton"
      ? styles.amtBtn_pink
      : styles.amtBtn;
  const amountTextClass =
    selectedBet?.buttonType === "RedButton"
      ? styles.amtBtn_txt_pink
      : styles.amtBtn_txt;
  const oddsBtnClass =
    selectedBet?.buttonType === "RedButton"
      ? styles.odds_btn_pink
      : styles.odds_btn_blue;
  const editButton =
    selectedBet?.buttonType === "RedButton"
      ? styles.Edit_button_pink
      : styles.Edit_button;
  const betDialogheader =
    selectedBet?.buttonType === "RedButton"
      ? styles.betDialog_header_pink
      : styles.betDialog_header;

  // ─── Roulette: bet.position → selection + choice ──────────────────────────
  const getRouletteSelectionAndChoice = (bet) => {
    // Outside bet — area se map karo
    if (bet?.area) {
      const areaMap = {
        zero: { selection: "STRAIGHT", choice: "0" },
        red: { selection: "RED", choice: "RED" },
        black: { selection: "BLACK", choice: "BLACK" },
        odd: { selection: "ODD", choice: "ODD" },
        even: { selection: "EVEN", choice: "EVEN" },
        low: { selection: "LOW", choice: "LOW" },
        high: { selection: "HIGH", choice: "HIGH" },
        dozen1: { selection: "DOZEN_1ST", choice: "DOZEN_1ST" },
        dozen2: { selection: "DOZEN_2ND", choice: "DOZEN_2ND" },
        dozen3: { selection: "DOZEN_3RD", choice: "DOZEN_3RD" },
        column1: { selection: "COLUMN_1", choice: "COLUMN_1" },
        column2: { selection: "COLUMN_2", choice: "COLUMN_2" },
        column3: { selection: "COLUMN_3", choice: "COLUMN_3" },
      };
      return areaMap[bet.area] || { selection: "STRAIGHT", choice: bet.area };
    }



    
    // Inside bet — position + numbers se map karo
    const choice = (bet?.numbers || []).join(",");
    switch (bet?.position) {
      case "center":
        return { selection: "STRAIGHT", choice };
      case "split-h":
      case "split-v":
        return { selection: "SPLIT", choice };
      case "street":
        return { selection: "STREET", choice };
      case "corner":
        return { selection: "CORNER", choice };
      case "line":
        return { selection: "SIX_LINE", choice };
      default:
        return { selection: "STRAIGHT", choice };
    }
  };
  // ─────────────────────────────────────────────────────────────────────────
const allInBg = selectedBet?.buttonType === 'RedButton' ? '#D89AA0' : '#FFA9A9';
const handleBetSubmit = async () => {
  if (isSubmitting) return;

  // ✅ Always derive fresh from socketData, not stale prop
  const liveRemaining = socketData?.remainingTime;
  const closed =
    socketData?.bettingClosed === true ||
    socketData?.type === "CARD_DEALT" ||
    (typeof liveRemaining === "number" && liveRemaining <= 0);

  if (closed) {
    showError("Betting is closed for this round");
    onClose();
    return;
  }

  if (!selectedAmount || !selectedBet) {
    console.warn("Missing selectedAmount or selectedBet");
    return;
  }

 const stake = parseFloat(selectedAmount);
const minStake = parseFloat(minRange) || 0;
const maxStake = parseFloat(maxRange) || Infinity;

if (isNaN(stake) || stake <= 0) {
  showError("Please enter a valid stake amount.");
  return;
}

if (stake < minStake) {
  showError(`Minimum stake is ${minStake}.`);
  return;
}

if (stake > maxStake) {
  showError(`Maximum stake is ${maxStake}.`);
  return;
}
  const label = selectedBet?.betType?.toLowerCase() || "";
  let betType = label
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/gi, "");

  if (!betType || typeof betType !== "string") {
    console.warn("Invalid betType:", selectedBet);
    return;
  }

  betType = betType.toLowerCase().trim();
  let formattedBetType = betType.toUpperCase();

  if (gameId === 4) {
    formattedBetType = selectedBet?.betType ?? "MAIN";
  } else if (gameId === 5) {
    formattedBetType = selectedBet.betType;
  } else if (gameId === 12) {
    formattedBetType = selectedBet.betType;
  } else if (gameId === 1) {
    formattedBetType = selectedBet.betType;
  } else if (gameId === 9) {
    formattedBetType = selectedBet.betType;
  } else if (gameId === 10) {
    formattedBetType = selectedBet.betType;
  } else if (gameId === 13) {
    formattedBetType = selectedBet.betType;
  } else if (gameId === 8) {
    const sideTypes = [
      "odd",
      "even",
      "red",
      "black",
      "dulha_dulhan",
      "barati",
      "side",
    ];
    if (betType === "back") formattedBetType = "BACK";
    else if (betType === "lay") formattedBetType = "LAY";
    else if (sideTypes.includes(betType)) formattedBetType = "SIDE";
  } else if (gameId === 11) {
    formattedBetType = betType.toUpperCase();
  } else if (gameId === 6) {
    formattedBetType = selectedBet?.marketName;
  } else if (gameId === 7) {
    formattedBetType = selectedBet.betType;
  } else if (gameId === 3) {
    formattedBetType = "BACK";
  }

  // ✅ betData PEHLE declare karo
  const betData = {
    userId: parseInt(userId, 10),
    rate: selectedBet?.odds ?? selectedBet?.rate ?? 0,
    roundId: parseInt(roundId, 10),
    betType: formattedBetType,
    selection: selectedBet?.selection,
    stake: stake,
    cardGuess: selectedBet?.cardGuess,
    marketName: selectedBet?.marketName ?? undefined,
  };

  // ✅ Phir gameId === 8 override
  if (gameId === 8 && formattedBetType === "SIDE") {
    if (selectedBet?.cardGuess) {
      betData.selection = selectedBet.selection;
      betData.cardGuess = selectedBet.cardGuess;
    } else {
      betData.selection = betType.toUpperCase();
      betData.cardGuess = null;
    }
  }

  // ✅ gameId === 3 (Roulette) — selection + choice derive karo
  if (gameId === 3) {
    const { selection, choice } = getRouletteSelectionAndChoice(selectedBet);
    betData.selection = selection;
    betData.choice = choice;
  }

  setIsSubmitting(true); 

  try {
    let dispatchPromise;
    if (gameId === 5) dispatchPromise = dispatch(placeAndarBaharBet(betData));
    else if (gameId === 11) dispatchPromise = dispatch(placeAAABet(betData));
    else if (gameId === 1)
      dispatchPromise = dispatch(placeteenpatti20(betData));
    else if (gameId === 9)
      dispatchPromise = dispatch(placeteenpattitwocard(betData));
    else if (gameId === 4) dispatchPromise = dispatch(placelucky(betData));
    else if (gameId === 6)
      dispatchPromise = dispatch(placedrogontiger(betData));
    else if (gameId === 7)
      dispatchPromise = dispatch(placedrogontigerlion(betData));
    else if (gameId === 8)
      dispatchPromise = dispatch(placebollywood(betData));
    else if (gameId === 12) dispatchPromise = dispatch(placecard32(betData));
    else if (gameId === 10)
      dispatchPromise = dispatch(placebaccarat(betData));
    else if (gameId === 13)
      dispatchPromise = dispatch(placeonedaydt(betData));
    else if (gameId === 3)
      dispatchPromise = dispatch(placeBetRoualete(betData));
    else {
      console.warn(`Unsupported gameId: ${gameId}`);
      setIsSubmitting(false);
      return;
    }

    await dispatchPromise.unwrap();
    showSuccess("Bet placed successfully");
    onClose();
  } catch (error) {
  const backendMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.data?.message ||
    error?.message ||
    "Bet placement failed";

  showError(backendMessage);
  console.error("Backend error:", error?.response?.data || error);
} finally {
  setIsSubmitting(false);
}
};

  return (
    <Box className={styles.MatchScreen_container}>
      <Box>
        <Box className={betDialogheader}>
          <Typography className={styles.betDialog_header_txt}>
            Betslip
          </Typography>
          <span onClick={onClose} style={{ cursor: "pointer" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              style={{ cursor: "pointer" }}
            >
              <g clipPath="url(#clip0)">
                <path
                  d="M0.586047 12.0001C0.470144 12.0001 0.356837 11.9657 0.26046 11.9014C0.164083 11.837 0.0889654 11.7455 0.0446082 11.6384C0.000250996 11.5313 -0.0113527 11.4135 0.0112649 11.2998C0.0338824 11.1861 0.0897052 11.0817 0.171672 10.9998L10.9998 0.17164C11.1097 0.0617407 11.2588 0 11.4142 0C11.5696 0 11.7186 0.0617407 11.8285 0.17164C11.9384 0.281539 12.0002 0.430594 12.0002 0.586015C12.0002 0.741436 11.9384 0.890491 11.8285 1.00039L1.00042 11.8285C0.946056 11.883 0.881462 11.9262 0.810351 11.9556C0.739239 11.9851 0.663012 12.0002 0.586047 12.0001Z"
                  fill="white"
                />
                <path
                  d="M11.4141 12.0001C11.3372 12.0002 11.2609 11.9851 11.1898 11.9556C11.1187 11.9262 11.0541 11.883 10.9998 11.8285L0.17164 1.00039C0.0617407 0.890491 0 0.741436 0 0.586015C0 0.430594 0.0617407 0.281539 0.17164 0.17164C0.281539 0.0617407 0.430594 0 0.586015 0C0.741436 0 0.890491 0.0617407 1.00039 0.17164L11.8285 10.9998C11.9105 11.0817 11.9663 11.1861 11.9889 11.2998C12.0115 11.4135 11.9999 11.5313 11.9556 11.6384C11.9112 11.7455 11.8361 11.837 11.7397 11.9014C11.6433 11.9657 11.53 12.0001 11.4141 12.0001Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="12" height="12" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
        </Box>

        <Box className={dialogBackgroundClass}>
          <Box className={styles.oddBox_container_first}>
            <Box className={styles.betDialog_betforHeader}>
              <Typography
                className={styles.betDialog_label}
                style={{ marginTop: "5px" }}
              >
                {selectedBet?.label}
              </Typography>

              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: "4px",
                }}
              >
                {/* ✅ X button upar */}
                {/* <span onClick={onClose} style={{ cursor: 'pointer' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M0.586047 12.0001C0.470144 12.0001 0.356837 11.9657 0.26046 11.9014C0.164083 11.837 0.0889654 11.7455 0.0446082 11.6384C0.000250996 11.5313 -0.0113527 11.4135 0.0112649 11.2998C0.0338824 11.1861 0.0897052 11.0817 0.171672 10.9998L10.9998 0.17164C11.1097 0.0617407 11.2588 0 11.4142 0C11.5696 0 11.7186 0.0617407 11.8285 0.17164C11.9384 0.281539 12.0002 0.430594 12.0002 0.586015C12.0002 0.741436 11.9384 0.890491 11.8285 1.00039L1.00042 11.8285C0.946056 11.883 0.881462 11.9262 0.810351 11.9556C0.739239 11.9851 0.663012 12.0002 0.586047 12.0001Z" fill="black"/>
                <path d="M11.4141 12.0001C11.3372 12.0002 11.2609 11.9851 11.1898 11.9556C11.1187 11.9262 11.0541 11.883 10.9998 11.8285L0.17164 1.00039C0.0617407 0.890491 0 0.741436 0 0.586015C0 0.430594 0.0617407 0.281539 0.17164 0.17164C0.281539 0.0617407 0.430594 0 0.586015 0C0.741436 0 0.890491 0.0617407 1.00039 0.17164L11.8285 10.9998C11.9105 11.0817 11.9663 11.1861 11.9889 11.2998C12.0115 11.4135 11.9999 11.5313 11.9556 11.6384C11.9112 11.7455 11.8361 11.837 11.7397 11.9014C11.6433 11.9657 11.53 12.0001 11.4141 12.0001Z" fill="black"/>
                <defs><clipPath id="clip0"><rect width="12" height="12" fill="black"/></clipPath></defs>
            </svg>
        </span> */}

                {/* ✅ Profit neeche */}
                {/* <Box className={styles.betDialog_betfor}>
            <Typography className={styles.betDialog_betfortxt}>Profit</Typography>
            <Typography className={styles.betDialog_label}>
                {selectedAmount && selectedBet?.odds
                    ? ((selectedAmount * selectedBet.odds) - selectedAmount).toFixed(2)
                    : '0.00'}
            </Typography>
        </Box> */}
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Typography className={styles.betDialog_betfortxt}>
                    Profit
                  </Typography>
                  <Typography className={styles.betDialog_label}>
                    {selectedAmount && selectedBet?.odds
                      ? (
                          selectedAmount * selectedBet.odds -
                          selectedAmount
                        ).toFixed(2)
                      : "0.00"}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box className={styles.oddBox_container_main}>
              <Box className={styles.oddBox_container}>
                <Typography className={styles.oddBox_txt}>Odds</Typography>
                <Box className={styles.oddBox_with_buttons}>
                  <Box className={`${styles.odds_minus_btn} ${oddsBtnClass}`}>
                    <Typography className={styles.odds_btn_txt}>-</Typography>
                  </Box>
                  <Box className={styles.odds_input_box}>
                    <Typography className={styles.StakeBox_TextField}>
                      {selectedBet?.odds}
                    </Typography>
                  </Box>
                  <Box className={`${styles.odds_plus_btn} ${oddsBtnClass}`}>
                    <Typography className={styles.odds_btn_txt}>+</Typography>
                  </Box>
                </Box>
              </Box>
              <Box className={styles.oddBox_container}>
                <Typography className={styles.oddBox_txt}>Stake</Typography>
                <Box className={styles.oddBox}>
                  <input
                    type="number"
                    value={selectedAmount !== null ? selectedAmount : ""}
                    onChange={(e) => {
                      const val = parseFloat(e.target.value);
                      setSelectedAmount(isNaN(val) ? null : val);
                    }}
                    placeholder="Select Amount"
                    className={styles.StakeBox_TextField}
                  />
                </Box>
              </Box>
            </Box>
          </Box>

          <Box className={styles.amtBtn_container}>
            {currentAmountList.map((item, idx) => (
              <Button
                key={idx}
                className={`${amountButtonClass} ${selectedAmount === item.value ? styles.amtBtn_selected : ""}`}
                onClick={() => handleAmountClick(item.value)}
                sx={{ minHeight: "18px", padding: "10px 0" }}
              >
                <Typography
                  className={amountTextClass}
                  sx={{ fontSize: "12px", fontWeight: 600 }}
                >
                  +{item.label}
                </Typography>
              </Button>
            ))}
          </Box>

          {/* ── NEW: MIN / MAX / ALL IN / CLEAR ── */}
          <Box
            className={styles.amtBtn_container}
            style={{ display: "flex", marginTop: "0px", marginBottom: "4px" }}
          >
            <Button
              onClick={handleMinClick}
              style={{
                flex: 1,
                background: "#C9FFBC",
                padding: "6px 0",
                minWidth: 0,
                textTransform: "none",
              }}
            >
              <Typography
                style={{ fontWeight: 600, fontSize: "12px", color: "#1a6e1a" }}
              >
                MIN
              </Typography>
            </Button>
            <Button
              onClick={handleMaxClick}
              style={{
                flex: 1,
                background: "#FFE8BF",
                padding: "6px 0",
                minWidth: 0,
                textTransform: "none",
              }}
            >
              <Typography
                style={{ fontWeight: 700, fontSize: "12px", color: "#b06000" }}
              >
                MAX
              </Typography>
            </Button>
           <Button
    onClick={handleAllInClick}
    style={{ flex: 1, background: allInBg, padding: '6px 0', minWidth: 0, textTransform: 'none' }}
>
              <Typography
                style={{ fontWeight: 700, fontSize: "12px", color: "#b00000" }}
              >
                All IN
              </Typography>
            </Button>
            <Button
              onClick={handleClearClick}
              style={{
                flex: 1,
                background: "#DB3434",
                padding: "6px 0",
                minWidth: 0,
                textTransform: "none",
              }}
            >
              <Typography
                style={{ fontWeight: 700, fontSize: "12px", color: "#fff" }}
              >
                CLEAR
              </Typography>
            </Button>
          </Box>
          {/* ─────────────────────────────────────── */}

          <Box className={styles.betDialog_bottom_container}>
            {/* Full width Cancel + Submit */}
            <Box
              style={{
                display: "flex",
                gap: "8px",
                width: "100%",
                marginTop: "4px",
              }}
            >
              <Button
                onClick={onClose}
                style={{
                  flex: 1,
                  background: "#FF6A6A",
                  padding: "10px 0",
                  textTransform: "none",
                  borderRadius: "4px",
                }}
              >
                <Typography
                  style={{
                    fontWeight: 600,
                    fontSize: "13px",
                    color: "#212121",
                  }}
                >
                  Cancel
                </Typography>
              </Button>
              <Button
                onClick={handleBetSubmit}
                  disabled={selectedAmount === null || isSubmitting} 
                style={{
                  flex: 1,
                  background: "#49A712",
                  padding: "10px 0",
                  textTransform: "none",
                  borderRadius: "4px",
                }}
              >
                <Typography
                  style={{ fontWeight: 600, fontSize: "13px", color: "#fff" }}
                >
                  Submit
                </Typography>
              </Button>
            </Box>
          </Box>

          {/* ✅ Range — betDialog_bottom_container ke BAHAR */}
          <Typography className={styles.Range_txt}>
            Range: {minRange} to {maxRange}
          </Typography>
        </Box>
      </Box>

      <Dialog open={isSetButtonValueOpen} onClose={handleSetButtonValueClose}>
        <SetButtonValue
          onUpdate={handleUpdateAmountList}
          initialValues={initialValues}
          onClose={handleSetButtonValueClose}
        />
      </Dialog>
      <Dialog open={isEditStackOpen} onClose={handleEditStackClose}>
        <EditStack
          open={isEditStackOpen}
          onClose={handleEditStackClose}
          amountList={currentAmountList}
          onUpdate={handleUpdateAmountList}
        />
      </Dialog>
    </Box>
  );
};

export default BetScreen;
